module.exports = __webpack_public_path__ + "static/media/rain.c520e608.png";